export default __webpack_public_path__ + "static/media/dashboard_exclamation.8cee9aab.svg";